import { API_ENDPOINTS } from "@/api/endpoints.constant";
import { User } from "@/types/User";

export const logInfo = (apiUrl: string, token: string, user: User | null, message: string, data: any) => {
    logMessage(apiUrl, token, user, message, 'info', data);
}

export const logError = (apiUrl: string, token: string, user: User | null, message: string, data: any) => {
    logMessage(apiUrl, token, user, message, 'error', data);
}

export const logWarning = (apiUrl: string, token: string, user: User | null, message: string, data: any) => {
    logMessage(apiUrl, token, user, message, 'warning', data);
}


export const logDebug = (apiUrl: string, token: string, user: User | null, message: string, data: any) => {
    logMessage(apiUrl, token, user, message, 'debug', data);
}

const stringifyParameters = (optionalParams: unknown[]): string[] | null => {
    return optionalParams && optionalParams.length > 0
        ? optionalParams.map(param =>
            typeof param === 'string'
                ? param.replace(/\s+/g, ' ').trim()
                : JSON.stringify(param, null, 4)?.replace(/\s+/g, ' ').trim()
        )
        : null;
};
const logMessage = (apiUrl: string, token: string, user: User | null, message: string, level: string, data: any) => {

    if (!apiUrl || !token) {
        console.log(message, data);
        return;
    }

    try {
        const opts = {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                message,
                level,
                data: stringifyParameters([data]), // stringify data safely
                user
            }),
        };

        const urlObj = new URL(`${apiUrl}/${API_ENDPOINTS.LOGS.LOGS}`);

        fetch(urlObj.toString(), opts)
            .then(() => {
                console.log('Logs sent to server');
            })
            .catch((error) => {
                console.error('Error sending logs to server', error);
            });

    } catch (error) {
        console.error('Error while logging message', error);
    }
}